import { gql } from '@apollo/client';

/**
 * GraphQL mutation to create a strike policy.
 * Strike policies use strikeThreshold (point accumulation) instead of labels.
 */
export const CREATE_STRIKE_POLICY = gql`
  mutation CreateStrikePolicy($communityId: ID!, $input: CreatePolicyInput!) {
    createPolicy(communityId: $communityId, input: $input) {
      id
      communityId
      name
      description
      isEnabled
      workflowType
      strikeThreshold
      createdBy
      createdAt
      lastModifiedBy
      lastModifiedAt
    }
  }
`;
